class TabWrapper extends HTMLElement {
  constructor() {
    super();

    this.container = this;

    if (this.container.querySelectorAll("tab-header").length) {
      this.container.querySelectorAll("tab-header").forEach((tabHeader) => {
        tabHeader.addEventListener("click", (e) => {
          if (e.currentTarget.classList.contains("active")) return;

          this.dataIndex = e.currentTarget.getAttribute("data-index");
          this.container.querySelector("tab-header.active").classList.remove("active");
          this.container.querySelector("tab-content.active").classList.remove("active");

          e.currentTarget.classList.add("active");
          this.container.querySelector('tab-content[data-index="' + this.dataIndex + '"]').classList.add("active");
        });
      });
    }
  }
}

customElements.define("tab-wrapper", TabWrapper);

class CalculatorVariants extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    if (this.container.querySelectorAll("calculator-select").length == 0) return;

    if (document.querySelectorAll("[data-inventories-json]").length > 0) {
      this.jsonData = JSON.parse(document.querySelector("[data-inventories-json]").innerHTML);
      this.variantsInventories = this.jsonData["inventories"] || {};
    } else {
      this.variantsInventories = {};
    }

    this.optionsSize = this.container.querySelectorAll("calculator-select").length;
    this.selectHandle();
  }

  selectHandle() {
    // Click option
    this.container.querySelectorAll(".js-calculator-option").forEach((calculatorOption) => {
      calculatorOption.addEventListener("click", (e) => {
        e.stopPropagation();

        if (e.currentTarget.classList.contains("active")) {
          return;
        }

        if (e.currentTarget.parentNode.querySelectorAll(".js-calculator-option.active").length > 0) {
          e.currentTarget.parentNode.querySelector(".js-calculator-option.active").classList.remove("active")
        }
        e.currentTarget.classList.add("active");

        this.selectElm = e.currentTarget.closest("calculator-select");
        this.labelElm = this.selectElm.querySelector(".js-calculator-label");
        this.dataValue = e.currentTarget.getAttribute("data-value");
        this.dataHTML = e.currentTarget.innerHTML;

        this.labelElm.setAttribute("data-value", this.dataValue);
        this.labelElm.querySelector(".js-calculator-label-text").innerHTML = this.dataHTML;
        this.labelElm.classList.remove("active");
        this.selectElm.classList.add("selected");

        // The total sq.ft should automatically revert to the default value
        document.querySelector(".js-product-calculator-input").value = "";

        if (e.currentTarget.classList.contains("js-calculator-bullnose")) {
          this.selectElm.setAttribute("data-bullnose", e.currentTarget.getAttribute("data-bullnose"));
        }

        if (this.container.querySelectorAll("calculator-select.selected").length == this.optionsSize) {
          this.container.classList.add("select-done");
          document.querySelector(".js-select-option-warning").style.display = "none";

          this.updateOptions();
          this.updateMasterId();

          const calculatorAtc = document.querySelector("calculator-atc");

          if (this.currentVariant) {
            this.updateMedia();

            this.metafieldsData = JSON.parse(this.querySelector('.VariantMetafieldsJson[data-id="' + this.currentVariant.id + '"]').textContent);
            if (this.metafieldsData) {
              this.updateMetafields();
            }
            this.updateInventoryQuantity();
            window.calProductVariant = this.currentVariant;
            calculatorAtc.updateButton(true);
          } else {
            window.calProductVariant = 'unavailable';
            calculatorAtc.updateButton(true);
          }
        } else {
          this.container.classList.remove("select-done");
          document.querySelector(".js-select-option-warning").style.display = "block";
        }
      });
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateInventoryQuantity() {
    if (document.querySelectorAll(".js-product-calculator-atc").length > 0) {
      if (this.currentVariant.inventory_management == "shopify") {
        this.variantInventory = this.variantsInventories[this.currentVariant.id];
        this.inventoryQuantity = this.variantInventory["inventory_quantity"];

        document.querySelector(".js-product-calculator-atc").setAttribute("data-track-quantity", "shopify");
        document.querySelector(".js-product-calculator-atc").setAttribute("data-inventory-quantity", this.inventoryQuantity);
        document.querySelector(".js-product-calculator-atc").setAttribute("data-inventory-policy", this.variantInventory["inventory_policy"]);
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll(".js-calculator-label-text"), (element) => {
      return element.textContent.trim();
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMetafields() {
    window.metafieldsData = this.metafieldsData;
    // Update note
    if (document.querySelectorAll(".js-product-calculator-note").length > 0) {
      this.calculatorNoteElm = document.querySelector(".js-product-calculator-note");
      if (window.metafieldsData.noteHeader != "") {
        this.productNoteHeader = window.metafieldsData.noteHeader;
      } else {
        this.productNoteHeader = window.calculatorDefaultTexts.productNoteHeader;
      }

      if (window.metafieldsData.noteContent != "") {
        this.productNoteContent = window.metafieldsData.noteContent;
      } else {
        this.productNoteContent = window.calculatorDefaultTexts.productNoteContent;
      }

      this.calculatorNoteElm.querySelector(".product-calculator_note-header-text").textContent = this.productNoteHeader;
      this.calculatorNoteElm.querySelector(".product-calculator_note-content").textContent = this.productNoteContent;
      document.querySelector(".js-product-calculator-note").style.display = "block";
    }

    // Update price
    if (document.querySelectorAll(".js-calculator-pricePerPc").length > 0) {
      document.querySelector(".js-calculator-pricePerPc").innerHTML = Shopify.formatMoney(this.metafieldsData.pricePerPc * 100);
    }
    if (window.actualPercentage < 1 && document.querySelectorAll(".js-calculator-pricePerPc-sale").length > 0) {
      document.querySelector(".js-calculator-pricePerPc-sale").innerHTML = Shopify.formatMoney(
        this.metafieldsData.pricePerPc * 100 * window.actualPercentage
      );
    }

    this.methodValue = document.querySelector("calculator-result").getAttribute("data-method");
    if (this.methodValue == "c1") {
      this.pricePerArea = window.metafieldsData.pricePerSq * 100;
      this.areaPerBox = window.metafieldsData.sqPerBox;
    } else {
      this.pricePerArea = window.metafieldsData.pricePerLi * 100;
      this.areaPerBox = window.metafieldsData.liPerBox;
    }

    if (document.querySelectorAll(".js-calculator-pricePerSq").length > 0) {
      document.querySelector(".js-calculator-pricePerSq").innerHTML = Shopify.formatMoney(this.pricePerArea);
    }
    if (window.actualPercentage < 1 && document.querySelectorAll(".js-calculator-pricePerSq-sale").length > 0) {
      document.querySelector(".js-calculator-pricePerSq-sale").innerHTML = Shopify.formatMoney(this.pricePerArea * window.actualPercentage);
    }

    if (document.querySelectorAll(".js-calculator-areaBox").length > 0) {
      document.querySelector(".js-calculator-areaBox").textContent = this.areaPerBox;
    }

    if (document.querySelectorAll(".js-calculator-pricePerBox").length > 0) {
      document.querySelector(".js-calculator-pricePerBox").innerHTML = Shopify.formatMoney(this.metafieldsData.pricePerBox * 100);
    }
    if (window.actualPercentage < 1 && document.querySelectorAll(".js-calculator-pricePerBox-sale").length > 0) {
      document.querySelector(".js-calculator-pricePerBox-sale").innerHTML = Shopify.formatMoney(
        this.metafieldsData.pricePerBox * 100 * window.actualPercentage
      );
    }

    if (document.querySelectorAll(".js-calculator-total-price").length > 0) {
      document.querySelector(".js-calculator-total-price").setAttribute("data-price", this.metafieldsData.pricePerPc * 100 * window.actualPercentage);
    }

    if (document.querySelectorAll(".js-calculator-total-price-regular").length > 0) {
      document.querySelector(".js-calculator-total-price-regular").setAttribute("data-price-regular", this.metafieldsData.pricePerPc * 100);
    }

    // Update form
    if (document.querySelectorAll(".js-product-calculator-variant").length > 0) {
      document.querySelector(".js-product-calculator-variant").value = this.currentVariant.id;
    }
    if (document.querySelectorAll('.js-properties-noteHeader').length > 0) {
      document.querySelector('.js-properties-noteHeader').value = this.productNoteHeader;
    }
    if (document.querySelectorAll('[name="properties[_sqPerBox]"]').length > 0) {
      document.querySelector('[name="properties[_sqPerBox]"]').value = this.calculationMethodText;
    }

    this.pcsPerBox = parseInt(this.metafieldsData.pcsPerBox, 10);
    let qtyMin = Math.ceil(this.pcsPerBox / window.patternsBundle);
    if (window.productSettings.sellingIn == "box") {
      if (document.querySelectorAll('[name="properties[_pcsPerBox]"]').length > 0) {
        document.querySelector('[name="properties[_pcsPerBox]"]').value = this.pcsPerBox;
      }
    }

    if (document.querySelectorAll('[name="properties[_qtyMin]"]').length > 0) {
      document.querySelector('[name="properties[_qtyMin]"]').value = qtyMin;
    }

    // Re-calculator
    // if (
    //   document.querySelectorAll(".product-calculator_input-wrap.selected").length ==
    //   document.querySelectorAll(".product-calculator_input-wrap.active").length &&
    //   document.querySelectorAll("calculator-result").length > 0
    // ) {
    //   const calculatorResult = document.querySelector("calculator-result");
    //   calculatorResult.calculator(true);
    // }

    document.querySelector(".js-product-calculator-price").style.display = "flex";
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector("#ProductVariantJson").textContent);
    return this.variantData;
  }
}

customElements.define("calculator-variants", CalculatorVariants);

class CalculatorResult extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    this.overage = parseInt(this.container.querySelector('.js-product-calculator-select.active[data-type="overage"]').getAttribute('data-value'), 10);
    this.inputHandle();
  }

  inputHandle() {
    this.container.querySelector(".js-product-calculator-input").addEventListener("keyup", debounce((e) => {
      const calculatorAtc = document.querySelector("calculator-atc");
      calculatorAtc.loading(true);

      this.onChange(e);
    }, 500).bind(this));

    this.container.querySelectorAll(".js-product-calculator-select").forEach((select) => {
      select.addEventListener("click", (e) => {
        e.stopPropagation();

        this.selectElm = e.currentTarget.closest("calculator-properties");
        this.labelElm = this.selectElm.querySelector(".js-calculator-label");
        this.labelElm.classList.remove("active");

        if (!e.currentTarget.classList.contains("active")) {
          if (e.currentTarget.getAttribute("data-type") == "overage") {
            this.overage = parseInt(e.currentTarget.getAttribute("data-value"), 10);

            if (this.overage == 0) {
              document.querySelector(".js-overage-warning").style.display = "block";
            } else {
              document.querySelector(".js-overage-warning").style.display = "none";
            }
          } else if (e.currentTarget.getAttribute("data-type") == "unit") {
            // Select unit
            this.methodValue = e.currentTarget.getAttribute("data-value");
            this.container.setAttribute("data-method", this.methodValue);
            this.methodText = e.currentTarget.innerHTML;

            e.currentTarget.closest(".product-calculator_input-wrap").classList.add("selected");
            e.currentTarget.closest(".product-calculator__select").classList.add("selected");

            // if (this.methodValue == "c2") {
            //   document.querySelector(".js-product-calculator-bullnose").classList.add("active");
            // } else if (document.querySelectorAll(".js-product-calculator-bullnose").length > 0) {
            //   document.querySelector(".js-product-calculator-bullnose").classList.remove("active");
            // }

            this.changeUnit();
          }

          this.labelElm.querySelector("div").innerHTML = e.currentTarget.innerHTML;
          if (this.selectElm.querySelectorAll(".js-product-calculator-select.active").length > 0) {
            this.selectElm.querySelector(".js-product-calculator-select.active").classList.remove("active");
          }
          e.currentTarget.classList.add("active");

          if (
            document.querySelectorAll(".product-calculator_input-wrap.selected").length ==
            document.querySelectorAll(".product-calculator_input-wrap.active").length
          ) {
            // Check if there is variant
            if (document.querySelectorAll("calculator-variants").length > 0) {
              // Check if variant is selected
              if (document.querySelector("calculator-variants").classList.contains("select-done")) {
                this.calculator();
              }
            } else {
              this.calculator();
            }
          }
        }
      });
    });
  }

  onChange(e) {
    this.sqftNeeded = parseInt(e.target.value, 10);

    if (isNaN(this.sqftNeeded)) {
      e.target.parentNode.classList.remove("selected");
    } else {
      e.target.parentNode.classList.add("selected");
    }

    if (
      document.querySelectorAll(".product-calculator_input-wrap.selected").length == document.querySelectorAll(".product-calculator_input-wrap.active").length
    ) {
      this.calculator();
    } else {
      document.querySelector(".js-product-calculator-result").style.display = "none";
    }
  }

  changeUnit() {
    if (this.methodValue == "c1") {
      this.pricePerArea = window.metafieldsData.pricePerSq * 100;
      this.areaPerBox = window.metafieldsData.sqPerBox;

      if (document.querySelectorAll(".js-calculator-areaBox").length > 0) {
        document.querySelector(".js-calculator-areaBox").textContent = this.areaPerBox;
      }
      if (document.querySelectorAll(".js-calculator-sqftPerBox").length > 0) {
        document.querySelector(".js-calculator-sqftPerBox").style.display = "block";
      }
    } else {
      this.pricePerArea = window.metafieldsData.pricePerLi * 100;
      // this.areaPerBox = window.metafieldsData.liPerBox;
      if (document.querySelectorAll(".js-calculator-sqftPerBox").length > 0) {
        document.querySelector(".js-calculator-sqftPerBox").style.display = "none";
      }
    }

    if (document.querySelectorAll(".js-calculator-pricePerSq").length > 0) {
      document.querySelector(".js-calculator-pricePerSq").innerHTML = Shopify.formatMoney(this.pricePerArea);
    }
    if (window.actualPercentage < 1 && document.querySelectorAll(".js-calculator-pricePerSq-sale").length > 0) {
      document.querySelector(".js-calculator-pricePerSq-sale").innerHTML = Shopify.formatMoney(this.pricePerArea * window.actualPercentage);
    }

    document.querySelectorAll(".js-method-name").forEach((elm) => {
      elm.textContent = this.methodText;
      // if (this.methodText == "linear ft" && elm.classList.contains("js-method-short-name")) {
      //   elm.textContent = "LF";
      // }
    });
  }

  calculator(firstLoad) {
    if (this.container.querySelector('.js-product-calculator-input[data-type="sqft"]').value != "" && this.container.querySelector('.js-product-calculator-input[data-type="sqft"]').value != '0') {
      if (document.querySelectorAll("calculator-variants").length > 0) {
        let optionsSize = document.querySelectorAll("calculator-variants calculator-select").length;
        if (document.querySelectorAll("calculator-select.selected").length != optionsSize) {
          return;
        }
      }

      if (firstLoad) {
        this.sqftNeeded = parseInt(this.container.querySelector('.js-product-calculator-input[data-type="sqft"]').value, 10);
        this.overage = parseInt(this.container.querySelector('.js-product-calculator-select.active[data-type="overage"]').getAttribute('data-value'), 10);
      }

      this.calculatorMethod = this.container.getAttribute("data-method");

      this.pcsPerBox = parseInt(window.metafieldsData.pcsPerBox, 10);
      this.buttonSubmit = document.querySelector(".js-product-calculator-atc");

      this.sqftOverage = (this.sqftNeeded * this.overage) / 100;
      this.sqftNeededTotal = this.sqftNeeded + this.sqftOverage;

      if (this.calculatorMethod == "c1") {
        this.calculationMethodText = "SQ.FT";

        this.tileSize = 1 / parseFloat(window.metafieldsData.pcsPerSq);
        this.totalPieces = Math.ceil(this.sqftNeededTotal / this.tileSize);
      } else {
        this.calculationMethodText = "LF";

        this.tileSize = 1 / parseFloat(window.metafieldsData.pcsPerLi);

        // this.bullnose = this.container.querySelector("#product-calculator_input-bullnose").value;
        this.bullnose = "short";
        if (document.querySelectorAll(".product-calculator__select-bullnose").length > 0) {
          this.bullnose = document.querySelector(".product-calculator__select-bullnose").getAttribute("data-bullnose");
        } else if (document.querySelectorAll(".product-calculator__select-size .js-calculator-label-text").length > 0) {
          this.optionSize = document.querySelector(".product-calculator__select-size .js-calculator-label-text").textContent.replace(/\D/g, "");
          this.optionSizeNumber = parseFloat(this.optionSize);
          this.tileLength = parseFloat(window.metafieldsData.length);
          if (this.optionSizeNumber == this.tileLength) {
            this.bullnose = "long";
          }
        }

        this.linToInches = 12;
        if (this.bullnose == "short") {
          this.pcsPerLin = this.linToInches / parseFloat(window.metafieldsData.width);
          this.tileSize = window.metafieldsData.width;
        } else {
          this.pcsPerLin = this.linToInches / parseFloat(window.metafieldsData.length);
          this.tileSize = window.metafieldsData.length;
        }
        this.totalPieces = Math.ceil(this.pcsPerLin * this.sqftNeededTotal);
      }

      // if (window.productSettings.sellingIn == 'box') {
      this.totalBox = Math.ceil(this.totalPieces / this.pcsPerBox);
      this.boxToPieces = this.totalBox * this.pcsPerBox;
      // } else {
      //   this.boxToPieces = this.totalPieces;
      // }

      this.quantity = Math.ceil(this.boxToPieces / window.patternsBundle);

      // Update again when calculating the number of bundles needed
      this.totalSqft = (this.quantity * window.patternsBundle * this.tileSize).toFixed(2);
      if (this.calculatorMethod == "c2") {
        this.totalSqft = (this.totalSqft / 12).toFixed(2);
      }
      // if (window.productSettings.sellingIn == 'pieces') {
      //   this.boxToPieces = this.quantity * window.patternsBundle;
      // }

      // Update result
      if (document.querySelectorAll(".js-calculator-totalBox").length > 0) {
        document.querySelector(".js-calculator-totalBox").textContent = this.totalBox;
      }
      if (document.querySelectorAll(".js-calculator-boxText").length > 0) {
        document.querySelector(".js-calculator-boxText").textContent = this.totalBox > 1 ? "Boxes" : "Box";
      }
      if (document.querySelectorAll(".js-calculator-totalPcs").length > 0) {
        document.querySelector(".js-calculator-totalPcs").textContent = this.quantity;
      }
      if (document.querySelectorAll(".js-calculator-totalSqft").length > 0) {
        document.querySelector(".js-calculator-totalSqft").textContent = this.totalSqft;
      }
      if (document.querySelectorAll(".js-calculator-total-price-regular").length > 0) {
        this.totalPriceRegularElm = document.querySelector(".js-calculator-total-price-regular");
        this.priceRegularPerPc = parseFloat(this.totalPriceRegularElm.getAttribute("data-price-regular"));
        this.totalPriceRegularElm.innerHTML = Shopify.formatMoney(this.quantity * window.patternsBundle * this.priceRegularPerPc);
      }
      if (document.querySelectorAll(".js-calculator-total-price").length > 0) {
        this.totalPriceElm = document.querySelector(".js-calculator-total-price");
        this.pricePerPc = parseFloat(this.totalPriceElm.getAttribute("data-price"));
        this.totalPriceElm.innerHTML = Shopify.formatMoney(this.quantity * window.patternsBundle * this.pricePerPc);
      }

      // Update form
      if (document.querySelectorAll('[name="properties[_areaPiece]"]').length > 0) {
        if (this.calculatorMethod == "c2") {
          this.tileSize = (this.tileSize / 12).toFixed(10);
        }
        document.querySelector('[name="properties[_areaPiece]"]').value = this.tileSize;
      }
      if (document.querySelectorAll(".js-product-calculator-quantity").length > 0) {
        document.querySelector(".js-product-calculator-quantity").value = this.quantity;
      }
      // if (document.querySelectorAll('[name="properties[total]"]').length > 0) {
      //   this.totalText = this.totalSqft + ' ' + this.calculationMethodText;
      //   if (window.productSettings.sellingIn == 'box') {
      //     this.totalText += ' | ' + this.totalBox + ' box';
      //   }
      //   document.querySelector('[name="properties[total]"]').value = this.totalText;
      // }
      if (document.querySelectorAll('[name="properties[_calculationMethodText]"]').length > 0) {
        document.querySelector('[name="properties[_calculationMethodText]"]').value = this.calculationMethodText;
      }

      // Update button ATC
      this.buttonSubmit.setAttribute("data-pieces-needed", this.totalPieces);
      this.buttonSubmit.setAttribute("data-total-pieces", this.boxToPieces);
      this.buttonSubmit.setAttribute("data-quantity", this.quantity);

      const calculatorAtc = document.querySelector("calculator-atc");
      calculatorAtc.updateButton(false);
    } else {
      document.querySelector(".js-product-calculator-result").style.display = "none";
    }
  }
}

customElements.define("calculator-result", CalculatorResult);

class CalculatorAtc extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("button");
  }

  async updateButton(isChangeVariant) {
    let variantAvailable = window.calProductVariant.available;
    
    if (isChangeVariant) {
      // when changing variant
      if (variantAvailable) {
        this.button.querySelector(".js-product-calculator-atc-text").textContent = window.variantStrings.addToCart;
        this.button.removeAttribute("disabled");
      } else {
        if (window.calProductVariant == 'unavailable') {
          this.button.querySelector(".js-product-calculator-atc-text").textContent = window.variantStrings.unavailable;
          this.button.setAttribute("disabled", "disabled");
        } else {
          this.button.querySelector(".js-product-calculator-atc-text").textContent = window.variantStrings.onBackOrder;
          this.button.setAttribute("disabled", "disabled");
        }
      }

      if (document.querySelectorAll(".js-product-calculator-note").length > 0) {
        document.querySelector(".js-product-calculator-note").style.display = "none";
      }
      document.querySelector(".js-product-calculator-result").style.display = "none";
    } else {
      // when calculating
      this.checkInventoryWarning = false;
      if (this.button.getAttribute("data-track-quantity") === "shopify" && variantAvailable) {
        this.inventoryQuantity = parseInt(this.button.getAttribute("data-inventory-quantity"), 10);
        this.totalPieces = parseInt(this.button.getAttribute("data-quantity"), 10);
        
        let variantId = window.calProductVariant.id;
        this.variantInCart = 0;
        this.cartItems = await fetch("/cart.js");
        this.cartItems = await this.cartItems.json();
        this.cartItems.items.map((item) => {
          if (item.variant_id == variantId) {
            this.variantInCart += item.quantity;
          }
        });

        this.remainingInventory = this.inventoryQuantity - this.variantInCart;

        this.button.setAttribute("data-remaining-inventory", this.remainingInventory);
        this.button.setAttribute("data-total-pieces", this.totalPieces);
        document.dispatchEvent(new CustomEvent("backorderCheck"));
 
        console.log('variantInCart: ', this.variantInCart);
        console.log('remainingInventory: ', this.remainingInventory);
        console.log('totalPieces: ', this.totalPieces);
        
        if (this.totalPieces > this.remainingInventory) {
          if (this.button.getAttribute("data-inventory-policy") == "continue") {
            this.button.querySelector(".js-product-calculator-atc-text").textContent = window.variantStrings.addToCart;
            this.button.removeAttribute("disabled");
            if (this.inventoryQuantity > 0) {
              if (window.metafieldsData.inventoryWarning != "") {
                this.inventoryWarningText = window.metafieldsData.inventoryWarning;
              } else {
                this.inventoryWarningText = window.calculatorDefaultTexts.inventoryWarning;
              }

              document.querySelector(".js-product-calculator_inventory-warning").textContent = this.inventoryWarningText;
              this.checkInventoryWarning = true;
            } else {
              document.querySelector(".js-product-calculator_inventory-warning").textContent = "";
            }
          } else {
            this.button.querySelector(".js-product-calculator-atc-text").textContent = window.variantStrings.onBackOrder;
            this.button.setAttribute("disabled", "disabled");

            document.querySelector(".js-product-calculator_inventory-warning").textContent = "";
          }
        } else {
          this.button.querySelector(".js-product-calculator-atc-text").textContent = window.variantStrings.addToCart;
          this.button.removeAttribute("disabled");
          document.querySelector(".js-product-calculator_inventory-warning").textContent = "";
        }
      }

      if (this.checkInventoryWarning && document.querySelector(".js-product-calculator_inventory-warning").getAttribute("data-warning") === "true") {
        if (document.querySelectorAll(".js-product-calculator-note").length > 0) {
          document.querySelector(".js-product-calculator-note").style.display = "none";
        }
        if (document.querySelectorAll('.js-properties-noteHeader').length > 0) {
          document.querySelector('.js-properties-noteHeader').value = this.inventoryWarningText;
        }
      } else {
        if (document.querySelectorAll(".js-product-calculator-note").length > 0) {
          document.querySelector(".js-product-calculator-note").style.display = "block";
        }
        if (document.querySelectorAll('.js-properties-noteHeader').length > 0) {
          if (window.metafieldsData.noteHeader != "") {
            this.productNoteHeader = window.metafieldsData.noteHeader;
          } else {
            this.productNoteHeader = window.calculatorDefaultTexts.productNoteHeader;
          }
          document.querySelector('.js-properties-noteHeader').value = this.productNoteHeader;
        }
      }

      document.querySelector(".js-product-calculator-result").style.display = "block";
      document.dispatchEvent(new CustomEvent("backorderCheck"));

      this.loading(false);
    }
  }

  loading(isLoading) {
    if (isLoading) {
      this.button.setAttribute("aria-disabled", true);
      this.button.classList.add("loading");
      this.querySelector(".loading__spinner").classList.remove("hidden");
    } else {
      this.button.removeAttribute("aria-disabled");
      this.button.classList.remove("loading");
      this.querySelector(".loading__spinner").classList.add("hidden");
    }
  }
}

customElements.define("calculator-atc", CalculatorAtc);

class SampleProduct extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    this.buttonSubmit = this.container.querySelector("button");
    if (!this.buttonSubmit) return;

    this.container.querySelectorAll(".js-calculator-option").forEach((sampleOption) => {
      sampleOption.addEventListener("click", (e) => {
        e.stopPropagation();

        this.selectElm = e.currentTarget.closest("sample-select");
        this.labelElm = this.selectElm.querySelector(".js-calculator-label");
        this.dataValue = e.currentTarget.getAttribute("data-value");
        this.dataHTML = e.currentTarget.innerHTML;
        this.dataName = e.currentTarget.getAttribute("data-name");

        this.labelElm.setAttribute("data-value", this.dataValue);
        this.labelElm.querySelector("div").innerHTML = this.dataHTML;
        this.labelElm.classList.remove("active");
        this.selectElm.classList.add("selected");
        if (this.container.querySelectorAll('[name="' + this.dataName + '"]').length > 0) {
          this.container.querySelector('[name="' + this.dataName + '"]').value = this.dataValue;
        }

        if (document.querySelectorAll("sample-select.selected").length == document.querySelectorAll("sample-select.active").length) {
          this.buttonSubmit.removeAttribute("disabled");
        }
      });
    });

    // this.container.querySelectorAll(".js-product-sample-select").forEach((select) => {
    //   select.addEventListener("change", (e) => {
    //     e.currentTarget.parentNode.classList.add("selected");

    //     if (document.querySelectorAll(".product-sample_input-wrap.selected").length == document.querySelectorAll(".product-sample_input-wrap.active").length) {
    //       this.buttonSubmit.removeAttribute("disabled");
    //     }
    //   });
    // });
  }
}

customElements.define("sample-product", SampleProduct);

window.addEventListener("DOMContentLoaded", () => {
  // Toggle select
  document.querySelectorAll(".js-calculator-label").forEach((calculatorSelects) => {
    calculatorSelects.addEventListener("click", (e) => {
      e.stopPropagation();

      if (e.currentTarget.classList.contains("active")) {
        e.currentTarget.classList.remove("active");
      } else {
        if (document.querySelectorAll(".js-calculator-label.active").length > 0) {
          document.querySelector(".js-calculator-label.active").classList.remove("active");
        }
        e.currentTarget.classList.add("active");
      }
    });
  });
});

// Close dropdown when click outside
window.onclick = function (event) {
  if (!event.target.matches(".js-calculator-label")) {
    if (document.querySelectorAll(".js-calculator-label.active").length > 0) {
      document.querySelector(".js-calculator-label.active").classList.remove("active");
    }
  }
};
window.addEventListener("pageshow", () => {
  // if (document.querySelectorAll(".js-product-calculator-select").length > 0) {
  //   document.querySelectorAll(".js-product-calculator-select").forEach((select) => {
  //     if (select.value != "") {
  //       select.parentNode.classList.add("selected");
  //     }
  //     if (select.getAttribute("data-type") == "unit") {
  //       if (document.querySelector("calculator-result").getAttribute("data-method") == "c2") {
  //         document.querySelector(".js-product-calculator-bullnose").classList.add("active");
  //       } else if (document.querySelectorAll(".js-product-calculator-bullnose").length > 0) {
  //         document.querySelector(".js-product-calculator-bullnose").classList.remove("active");
  //       }
  //     }
  //   });
  // }

  if (document.querySelectorAll(".js-product-calculator-input").length > 0) {
    document.querySelectorAll(".js-product-calculator-input").forEach((input) => {
      if (input.value != "") {
        input.parentNode.classList.add("selected");
      }
    });
  }

  if (
    document.querySelectorAll(".product-calculator_input-wrap.selected").length == document.querySelectorAll(".product-calculator_input-wrap.active").length &&
    document.querySelectorAll("calculator-result").length > 0
  ) {
    const calculatorResult = document.querySelector("calculator-result");
    calculatorResult.calculator(true);
  }
});
